import { calender_shift } from 'utils/customWebengage'

const CalenderHeader = ({ monthDate, decreaseMonth, increaseMonth, profile }) => {
    // Get the current month (0-indexed, so 3 = April, 4 = May)
    const currentMonth = monthDate.getMonth()

    const isApril = currentMonth === 3 // April = 3 (0-indexed)
    const isMay = currentMonth === 4 // May = 4 (0-indexed)

    return (
        <div className="custom-header">
            <div className="current-month">
                {monthDate.toLocaleString('en-US', {
                    month: 'long',
                })}{' '}
                2025
            </div>
            <div className="prev-next-container">
                <button
                    aria-label="Previous Month"
                    className={`chevron ${isApril ? 'disabled' : ''}`}
                    onClick={!isApril ? decreaseMonth : undefined}
                    disabled={isApril}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g id="Chevron">
                            <path
                                id="Vector"
                                d="M7.08301 10.667L11.833 15.3337C12.1663 15.667 12.6663 15.667 12.9997 15.3337C13.333 15.0003 13.333 14.5003 12.9997 14.167L8.91634 10.0003L12.9997 5.83366C13.333 5.50033 13.333 5.00033 12.9997 4.66699C12.833 4.50033 12.6663 4.41699 12.4163 4.41699C12.1663 4.41699 11.9997 4.50033 11.833 4.66699L7.08301 9.33366C6.74967 9.75033 6.74967 10.2503 7.08301 10.667C7.08301 10.5837 7.08301 10.5837 7.08301 10.667Z"
                                fill={isApril ? '#DDE2E5' : '#B5BEC6'}
                            />
                        </g>
                    </svg>
                </button>
                <button
                    aria-label="Next Month"
                    className={`chevron ${isMay ? 'disabled' : ''}`}
                    onClick={
                        !isMay
                            ? () => {
                                  increaseMonth()
                                  profile['month_changed'] = monthDate
                                  calender_shift(
                                      '5_Calendar_month_flip',
                                      profile,
                                      profile.exam_type,
                                  )
                              }
                            : undefined
                    }
                    disabled={isMay}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g id="Chevron">
                            <path
                                id="Vector"
                                d="M12.9499 9.40796L8.23328 4.69962C8.15581 4.62152 8.06364 4.55952 7.96209 4.51721C7.86054 4.47491 7.75162 4.45312 7.64161 4.45312C7.5316 4.45312 7.42268 4.47491 7.32113 4.51721C7.21958 4.55952 7.12741 4.62152 7.04994 4.69962C6.89474 4.85576 6.80762 5.06697 6.80762 5.28712C6.80762 5.50728 6.89474 5.71849 7.04994 5.87462L11.1749 10.0413L7.04994 14.1663C6.89474 14.3224 6.80762 14.5336 6.80762 14.7538C6.80762 14.9739 6.89474 15.1852 7.04994 15.3413C7.12712 15.42 7.21916 15.4827 7.32072 15.5256C7.42229 15.5685 7.53135 15.5908 7.64161 15.5913C7.75187 15.5908 7.86094 15.5685 7.9625 15.5256C8.06406 15.4827 8.1561 15.42 8.23328 15.3413L12.9499 10.633C13.0345 10.5549 13.102 10.4602 13.1482 10.3548C13.1944 10.2494 13.2182 10.1355 13.2182 10.0205C13.2182 9.90537 13.1944 9.79153 13.1482 9.68612C13.102 9.5807 13.0345 9.48599 12.9499 9.40796Z"
                                fill={isMay ? '#DDE2E5' : '#B5BEC6'}
                            />
                        </g>
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default CalenderHeader
